'use client';

export { default } from './PaginationItem';
export { default as paginationItemClasses } from './paginationItemClasses';
export * from './paginationItemClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/PaginationItem/index.js
// module id = 562
// module chunks = 25